// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.invalid-filename-dialog__input[data-v-9d7d9a49] {
	/* Ensure the helper text can always be shown without jumping */
	min-height: calc(var(--default-clickable-area) + 4 * var(--default-font-size));
}
`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/upload/dist/assets/InvalidFilenameDialog-DKMLP0ER.css"],"names":[],"mappings":";AACA;CACC,+DAA+D;CAC/D,8EAA8E;AAC/E","sourcesContent":["\n.invalid-filename-dialog__input[data-v-9d7d9a49] {\n\t/* Ensure the helper text can always be shown without jumping */\n\tmin-height: calc(var(--default-clickable-area) + 4 * var(--default-font-size));\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
